import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconVideo = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-video"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 35"
    fill="none"
    className={clsxm('text-primary h-[35px] w-[45px]', className)}
    {...props}
  >
    <path
      d="M6.37109 34.5742C4.48307 34.5742 3.0638 34.1055 2.11328 33.168C1.17578 32.2305 0.707031 30.8372 0.707031 28.9883V6.39062C0.707031 4.52865 1.17578 3.13542 2.11328 2.21094C3.0638 1.27344 4.48307 0.804688 6.37109 0.804688H38.4805C40.3685 0.804688 41.7812 1.27344 42.7188 2.21094C43.6562 3.14844 44.125 4.54167 44.125 6.39062V28.9883C44.125 30.8372 43.6562 32.2305 42.7188 33.168C41.7812 34.1055 40.3685 34.5742 38.4805 34.5742H6.37109ZM18.9297 25.1016L29.7305 18.7148C30.1211 18.4674 30.3099 18.1354 30.2969 17.7188C30.2969 17.2891 30.1081 16.957 29.7305 16.7227L18.9297 10.2969C18.5391 10.0625 18.1354 10.0234 17.7188 10.1797C17.3021 10.3359 17.0938 10.6289 17.0938 11.0586V24.3398C17.0938 24.7695 17.2891 25.069 17.6797 25.2383C18.0833 25.4076 18.5 25.362 18.9297 25.1016Z"
      fill="currentColor"
    />
  </svg>
);
